import { useNavigate } from "react-router-dom";
import { Button, Img, Input, Line, Text } from "components";
import { InputAdornment } from "@mui/material";
import globalRequest from "../../utils/global/globalRequest";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import { setSnackbar } from "../../redux/reducers/snackbar";
import * as CUSTOM from "../../utils/helper/custom";
import * as APIS from "../../utils/helper/Enum";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [disabledBtn, setDisabledBtn] = useState(false);
  
  /**
   * Save Form api
   */
  const saveNewsLatter = async (type = "new") => {
    if (!disabledBtn) {
      dispatch(changeLoader(true));
      try {
        let response = await globalRequest(
          APIS?.PAGES?.NEWSLATTER,
          "post",
          { email: email },
          {},
          true
        );
        response = response?.data;
        if (response?.status == "SUCCESS") {
          setEmail();
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "success",
            })
          );
        } else {
          dispatch(
            setSnackbar({
              snackbarOpen: true,
              snackbarMessage: response?.message,
              snackbarState: "error",
            })
          );
        }
      } catch (e) {
        dispatch(
          setSnackbar({
            snackbarOpen: true,
            snackbarMessage: e?.message,
            snackbarState: "error",
          })
        );
      }
      dispatch(changeLoader(false));
    }
  };

  useEffect(() => {
    let status = true;
    if (CUSTOM.isValidField(email, "email")) {
      status = false;
    }
    setDisabledBtn(status);
  }, [email]);

  return (
    <>
      <footer className="flex font-nunitoregular  items-center justify-center mx-auto w-full">
        <div className="flex flex-col items-center justify-center mx-auto max-w-[1110px] w-full">
          <div className="flex flex-col items-center justify-center w-full">
            <Line className="bg-black-900 h-px w-full" />
            <div className="flex xs:flex-col sm:flex-wrap flex-row sm:gap-x-10 sm:gap-y-6 xs:gap-y-4 items-start justify-between mt-12 w-full md:px-4">
              <div className="flex xs:flex-1 flex-col items-start justify-start w-auto sm:w-full">
                <Text
                  className="sm:text-3xl md:text-[32px] text-[34px] text-black-900"
                  size="txtnunitoBold34"
                >
                  RabbitHole
                </Text>
                <Text
                  className="mt-[0px] text-base text-black-900"
                  size="txtnunitoMedium16"
                >
                  {t("partyeveryday")}
                </Text>
                <div className="footer-input-row flex flex-col h-14 md:h-auto items-start justify-start mt-[29px] rounded-tl rounded-tr max-w-[364px] w-full">
                  <Input
                    placeholder={t("enterEmail")}
                    className="footer-input"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <Img
                          className={`h-6 w-6 cursor-pointer rtl:rotate-180 ${
                            disabledBtn ? "opacity-down" : ""
                          } `}
                          src="/images/img_play.svg"
                          alt="play"
                          onClick={(e) => {
                            if (!disabledBtn) {
                              saveNewsLatter();
                            }
                          }}
                        />
                      </InputAdornment>
                    }
                  ></Input>
                </div>
                <Text
                  className="leading-[20.00px] sm:mt-0 mt-3 text-gray-700 text-sm w-[77%] sm:w-full rtl:text-right"
                  size="txtnunitoRegular14"
                >
                  {t("subscribenewsletter")}
                </Text>
              </div>
              <div className="flex xs:flex-1 flex-col gap-[20px] items-start justify-start sm:mt-0 xs:mt-3 mt-[11px] w-auto xs:w-full">
                <Text
                  className="text-base text-gray-700"
                  size="txtnunitoRegular16Gray700"
                >
                  {t("quicklink")}
                </Text>
                <ul className="flex flex-col gap-[16px] items-start justify-start w-full common-column-list">
                  <li>
                    <Text
                      className="text-base text-black-900 rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/contactus")}
                    >
                      {t("contactus")}
                    </Text>
                  </li>
                  <li>
                    <Text
                      className="text-base text-black-900 rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/blog-list")}
                    >
                      {t("blog")}
                    </Text>
                  </li>
                  <li>
                    <Text
                      className="text-base text-black-900 rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/terms-and-conditions")}
                    >
                      {t("termandcondition")}
                    </Text>
                  </li>
                </ul>
              </div>
              <div className="flex xs:flex-1 flex-col gap-[20px] items-start justify-start sm:mt-0 mt-[11px] w-auto xs:w-full">
                <Text
                  className="text-base text-gray-700 xs:hidden"
                  size="txtnunitoRegular16Gray700"
                >
                  <br />
                </Text>
                <ul className="flex flex-col gap-[16px] items-start justify-start w-full common-column-list">
                  <li>
                    <Text
                      className="text-base text-black-900 rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/privacy-policy")}
                    >
                      {t("privacypolicy")}
                    </Text>
                  </li>
                  <li>
                    <Text
                      className="text-base text-black-900 rtl:text-right footer-link w-fit"
                      size="txtnunitoMedium16"
                      onClick={() => navigate("/return-policy")}
                    >
                      {t("returnpolicy")}
                    </Text>
                  </li>
                </ul>
              </div>
              <div className="flex xs:flex-1 flex-col gap-6 items-start justify-start xs:mt-3 mt-[11px] w-auto xs:w-full">
                <Text
                  className="text-base text-gray-700"
                  size="txtnunitoRegular16Gray700"
                >
                  {t("followus")}
                </Text>
                <ul className="flex flex-col gap-3 items-start justify-start w-full common-column-list">
                  {/* <li>
                    <div className="flex flex-row gap-2 items-center justify-start">
                      <Button className="bg-black-900 flex h-8 items-center justify-center p-2 rounded-[50%] w-8">
                        <Img
                          className="h-4"
                          src="/images/img_rifacebookfill.svg"
                          alt="rifacebookfill"
                        />
                      </Button>
                      <Text
                        className="text-base text-black-900"
                        size="txtnunitoMedium16"
                      >
                        Facebook
                      </Text>
                    </div>
                  </li> */}
                  <li>
                    <div
                      className="flex flex-row gap-2 items-center justify-start"
                      onClick={() => {
                        window.open("https://www.instagram.com/rabbitholesa", '_blank');
                      }}
                    >
                      <Button className="bg-black-900 flex h-8 items-center justify-center p-2 rounded-[50%] w-8">
                        <Img
                          className="h-4"
                          src="/images/img_riinstagramfill.svg"
                          alt="riinstagramfill"
                        />
                      </Button>
                      <Text
                        className="text-base text-black-900"
                        size="txtnunitoMedium16"
                      >
                        {t("instagram")}
                      </Text>
                    </div>
                  </li>
                  <li>
                    <div
                      className="flex flex-row gap-2 items-center justify-start"
                      onClick={() => {
                        window.open("https://twitter.com/rabbitholesa", '_blank');
                      }}
                    >
                      <Button className="bg-black-900 flex h-8 items-center justify-center p-2 rounded-[50%] w-8">
                        <Img
                          className="h-4"
                          src="/images/img_mditwitter.svg"
                          alt="mditwitter"
                        />
                      </Button>
                      <Text
                        className="text-base text-black-900"
                        size="txtnunitoMedium16"
                      >
                        {t("twitter")}
                      </Text>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <Line className="bg-black-900_75 h-px mt-12 w-full" />
            <div className="flex flex-row items-center justify-center py-[24px] sm:py-[16px] w-full md:px-4">
              <Text
                className="text-black-900 text-xs"
                size="txtnunitoRegular12"
              >
                {t("copyright2025RabbitHoleDotAllRightsReservedDot")}
              </Text>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

Footer.defaultProps = {};

export default Footer;
